import Q12 from './Q12';

export default Q12;
